// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/datasets.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { DatasetMetadataService } from "./datasets_pb";

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListDatasets
 */
export const listDatasets = DatasetMetadataService.method.listDatasets;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDataset
 */
export const getDataset = DatasetMetadataService.method.getDataset;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListDatasetRevisions
 */
export const listDatasetRevisions = DatasetMetadataService.method.listDatasetRevisions;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevision
 */
export const getDatasetRevision = DatasetMetadataService.method.getDatasetRevision;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionDownloadLinks
 */
export const getDatasetRevisionDownloadLinks = DatasetMetadataService.method.getDatasetRevisionDownloadLinks;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionPerformanceLinks
 */
export const getDatasetRevisionPerformanceLinks = DatasetMetadataService.method.getDatasetRevisionPerformanceLinks;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.RenameDataset
 */
export const renameDataset = DatasetMetadataService.method.renameDataset;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ArchiveDatasetRevision
 * @deprecated
 */
export const archiveDatasetRevision = DatasetMetadataService.method.archiveDatasetRevision;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ArchiveDatasetRevisions
 */
export const archiveDatasetRevisions = DatasetMetadataService.method.archiveDatasetRevisions;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.DeleteDataset
 */
export const deleteDataset = DatasetMetadataService.method.deleteDataset;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTiles
 * @deprecated
 */
export const listMaterializedAggregateTiles = DatasetMetadataService.method.listMaterializedAggregateTiles;

/**
 * Timeline skeletons for the TilesTimeline view; manifests are fetched
 * separately via ListMaterializedAggregateTilesForTimeline.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTileTimelines
 */
export const listMaterializedAggregateTileTimelines = DatasetMetadataService.method.listMaterializedAggregateTileTimelines;

/**
 * The TilesTimeline filter vocabulary, so the client keeps no parallel copy of it.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileFacets
 */
export const getMaterializedAggregateTileFacets = DatasetMetadataService.method.getMaterializedAggregateTileFacets;

/**
 * Facet values and counts for the TilesTimeline filter menu.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileFacetValues
 */
export const getMaterializedAggregateTileFacetValues = DatasetMetadataService.method.getMaterializedAggregateTileFacetValues;

/**
 * The active deployment's materialized aggregations that compute or read one feature.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetFeatureMaterializedAggregations
 */
export const getFeatureMaterializedAggregations = DatasetMetadataService.method.getFeatureMaterializedAggregations;

/**
 * Gaps per windowed feature with offline tiles, paged by fqn; features with no tiles are omitted.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListTileFeatureCoverage
 */
export const listTileFeatureCoverage = DatasetMetadataService.method.listTileFeatureCoverage;

/**
 * Full tile manifests for one timeline (one materialization_key_hash).
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTilesForTimeline
 */
export const listMaterializedAggregateTilesForTimeline = DatasetMetadataService.method.listMaterializedAggregateTilesForTimeline;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.ListMaterializedAggregateTileFiles
 */
export const listMaterializedAggregateTileFiles = DatasetMetadataService.method.listMaterializedAggregateTileFiles;

/**
 * Row-count-per-tile histogram for one timeline (one
 * materialization_key_hash). Each x point is a tile's coverage_lower_bound;
 * the value is the total stored row count of the newest manifest covering
 * that window, i.e. the number of distinct (primary key, group, bucket)
 * rows materialized for the window.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileRowCountChart
 */
export const getMaterializedAggregateTileRowCountChart = DatasetMetadataService.method.getMaterializedAggregateTileRowCountChart;

/**
 * Returns one extracted aggregate value per bucket for a primary key over a
 * bounded range. This endpoint intentionally does not accept arbitrary SQL.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileValues
 */
export const getMaterializedAggregateTileValues = DatasetMetadataService.method.getMaterializedAggregateTileValues;

/**
 * Signed download URLs for the raw parquet files a tile manifest points at.
 * The URIs are read from the manifest's own file rows, scoped to the caller's
 * environment, so a caller cannot ask the server to sign an arbitrary object.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetMaterializedAggregateTileDownloadLinks
 */
export const getMaterializedAggregateTileDownloadLinks = DatasetMetadataService.method.getMaterializedAggregateTileDownloadLinks;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.DeleteMaterializedAggregateTile
 */
export const deleteMaterializedAggregateTile = DatasetMetadataService.method.deleteMaterializedAggregateTile;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetRevisionPreview
 */
export const getDatasetRevisionPreview = DatasetMetadataService.method.getDatasetRevisionPreview;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GenerateDatasetStats
 */
export const generateDatasetStats = DatasetMetadataService.method.generateDatasetStats;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetEdfs
 */
export const getDatasetEdfs = DatasetMetadataService.method.getDatasetEdfs;

/**
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GenerateDatasetEdfs
 */
export const generateDatasetEdfs = DatasetMetadataService.method.generateDatasetEdfs;

/**
 * Mint a signed upload URI for a client-side file. Call once per file; the
 * first call leaves upload_session_id unset and the server returns one.
 * Subsequent calls should pass the same upload_session_id so the server can
 * group all objects together under one finalize.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.GetDatasetUploadUris
 */
export const getDatasetUploadUris = DatasetMetadataService.method.getDatasetUploadUris;

/**
 * Finalize an upload session. The server records a new dataset revision
 * pointing at all objects uploaded under upload_session_id and exposes the
 * dataset for queries. Each upload_session_id may be finalized at most once;
 * see FinalizeDatasetUploadRequest for the conflict contract. Not marked
 * IDEMPOTENT because automatic retries could race against finalize completion
 * and surface confusing ALREADY_EXISTS errors to callers.
 *
 * @generated from rpc chalk.server.v1.DatasetMetadataService.FinalizeDatasetUpload
 */
export const finalizeDatasetUpload = DatasetMetadataService.method.finalizeDatasetUpload;
